/** Service Line Template manifest: compact Form create + Detail panel, with template item and task relation boards. */
import { ActivityEntityName, EntityViewDisplay, ServiceLineTemplate, SurfaceType } from '@jms/model';
import { PLANNED_TASK_ENTITY } from '@workbuddy/entities/planned.task/planned.task.model';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

export const serviceLineTemplateManifest = registerManifest<ServiceLineTemplate>({
  entity: ActivityEntityName.ServiceLineTemplate,
  slug: 'service-line-template',
  board: {
    supportedDisplays: [EntityViewDisplay.Table],
    defaults: {
      header: {
        title: 'Service Lines',
        showSearch: true,
        showPaginator: false,
      },
    },
  },
  routes: {
    root: '/crm/service-plan-templates',
  },
  surfaces: {
    [SurfaceType.Form]: () => import('./surface/create/service.line.template.create.surface').then(module => module.serviceLineTemplateCreateFormSurface),
    [SurfaceType.Detail]: () => import('./surface/detail/service.line.template.detail.surface').then(module => module.serviceLineTemplateDetailSurface),
  },
  operations: {
    create: { surface: SurfaceType.Form, presentation: { mode: 'dialog', title: 'New service line', width: 'min(640px, calc(100vw - 40px))' } },
    edit: { surface: SurfaceType.Detail },
    preview: { surface: SurfaceType.Detail },
  },
  relations: {
    [ActivityEntityName.PlannedItem]: () => import('./relations/service.line.template.items.relation').then(module => module.serviceLineTemplateItemsBoardBuilder),
    [PLANNED_TASK_ENTITY]: () => import('./relations/service.line.template.tasks.relation').then(module => module.serviceLineTemplateTasksBoardBuilder),
  },
});
